(function(){
  var d=document,root=d.documentElement;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var header=d.querySelector('[data-header]');
  function setH(){ if(header){ root.style.setProperty('--header-h', header.offsetHeight+'px'); } }
  setH(); window.addEventListener('resize', setH);
  function onScroll(){ if(header){ header.classList.toggle('is-scrolled', window.scrollY>20); } }
  onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

  var burger=d.querySelector('.ir-burger');
  if(burger&&header){
    var close=function(){ header.classList.remove('is-open'); d.body.classList.remove('ir-lock'); burger.setAttribute('aria-expanded','false'); burger.setAttribute('aria-label','Menu openen'); };
    burger.addEventListener('click', function(){
      var open=header.classList.toggle('is-open');
      d.body.classList.toggle('ir-lock', open);
      burger.setAttribute('aria-expanded', open?'true':'false');
      burger.setAttribute('aria-label', open?'Menu sluiten':'Menu openen');
    });
    header.querySelectorAll('.ir-nav a').forEach(function(a){ a.addEventListener('click', close); });
    d.addEventListener('keydown', function(e){ if(e.key==='Escape'&&header.classList.contains('is-open')){ close(); burger.focus(); } });
  }

  var hasIO='IntersectionObserver' in window;
  var io=hasIO?new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  },{threshold:.15,rootMargin:'0px 0px -40px 0px'}):null;
  d.querySelectorAll('[data-reveal]').forEach(function(el){ if(io){ io.observe(el); } else { el.classList.add('is-in'); } });

  d.querySelectorAll('[data-count]').forEach(function(el){
    var m=el.textContent.trim().match(/^(\D*)([\d.]+)(\D*)$/);
    if(!m||reduce||!hasIO){ return; }
    var target=parseInt(m[2].replace(/\./g,''),10);
    if(isNaN(target)){ return; }
    var o=new IntersectionObserver(function(es){
      if(!es[0].isIntersecting){ return; }
      o.disconnect();
      var t0=performance.now(),dur=1600;
      (function step(t){
        var p=Math.min((t-t0)/dur,1),e=1-Math.pow(1-p,3);
        el.textContent=m[1]+Math.round(target*e).toLocaleString('nl-NL')+m[3];
        if(p<1){ requestAnimationFrame(step); }
      })(t0);
    },{threshold:.6});
    o.observe(el);
  });

  d.querySelectorAll('[data-features]').forEach(function(sec){
    var items=sec.querySelectorAll('[data-feature]'),hots=sec.querySelectorAll('[data-hot]');
    function act(i){
      items.forEach(function(x,j){ x.classList.toggle('is-active', j===i); });
      hots.forEach(function(x,j){ x.classList.toggle('is-active', j===i); x.setAttribute('aria-pressed', j===i?'true':'false'); });
    }
    items.forEach(function(it,i){ it.addEventListener('mouseenter', function(){ act(i); }); it.addEventListener('focusin', function(){ act(i); }); });
    hots.forEach(function(h,i){ h.addEventListener('click', function(){ act(i); if(items[i]){ items[i].scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'}); } }); });
    if(items.length){ act(0); }
  });

  d.querySelectorAll('[data-colors]').forEach(function(sec){
    var svg=sec.querySelector('.ir-glasses'),name=sec.querySelector('[data-color-name]');
    var sw=sec.querySelectorAll('[data-swatch]');
    sw.forEach(function(b){
      b.addEventListener('click', function(){
        sw.forEach(function(x){ x.setAttribute('aria-pressed','false'); });
        b.setAttribute('aria-pressed','true');
        if(svg){ svg.style.setProperty('--frame', b.dataset.frame); svg.style.setProperty('--lens', b.dataset.lens); svg.style.setProperty('--tip', b.dataset.tip); }
        if(name){ name.textContent=b.dataset.name; }
      });
    });
  });

  d.querySelectorAll('[data-product]').forEach(function(sec){
    var json=sec.querySelector('[data-product-json]');
    var idInput=sec.querySelector('[data-variant-id]');
    var prices=sec.querySelectorAll('[data-price]');
    var adds=sec.querySelectorAll('[data-add]');
    var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
    function money(c){ return new Intl.NumberFormat('nl-NL',{style:'currency',currency:cur}).format(c/100); }
    if(json&&idInput){
      var variants=JSON.parse(json.textContent);
      var update=function(){
        var sel=[];
        sec.querySelectorAll('[data-option-index]').forEach(function(fs){
          var c=fs.querySelector('input:checked'),lbl=fs.querySelector('[data-option-value]');
          if(c&&lbl){ lbl.textContent=c.value; }
          sel.push(c?c.value:null);
        });
        var v=variants.find(function(v){ return v.options.every(function(o,i){ return o===sel[i]; }); });
        if(!v){ adds.forEach(function(b){ b.disabled=true; b.textContent='Niet beschikbaar'; }); return; }
        idInput.value=v.id;
        prices.forEach(function(p){ p.innerHTML=money(v.price)+(v.compare_at_price&&v.compare_at_price>v.price?' <s>'+money(v.compare_at_price)+'</s>':''); });
        adds.forEach(function(b){ b.disabled=!v.available; b.textContent=v.available?'In winkelwagen':'Uitverkocht'; });
        if(v.featured_media&&v.featured_media.preview_image){
          var main=sec.querySelector('[data-main-img]');
          if(main){ main.src=v.featured_media.preview_image.src; main.removeAttribute('srcset'); }
        }
        try{ var u=new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({},'',u.toString()); }catch(e){}
      };
      sec.querySelectorAll('[data-option-index] input').forEach(function(i){ i.addEventListener('change', update); });
    }
    sec.querySelectorAll('[data-qty]').forEach(function(w){
      var inp=w.querySelector('input');
      w.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click', function(){ var n=(parseInt(inp.value,10)||1)+(b.dataset.step==='up'?1:-1); inp.value=Math.max(1,n); });
      });
    });
    sec.querySelectorAll('[data-thumb]').forEach(function(t){
      t.addEventListener('click', function(){
        var main=sec.querySelector('[data-main-img]');
        if(main){ main.src=t.dataset.src; main.removeAttribute('srcset'); }
        sec.querySelectorAll('[data-thumb]').forEach(function(x){ x.setAttribute('aria-current','false'); });
        t.setAttribute('aria-current','true');
      });
    });
    var sticky=sec.querySelector('[data-sticky-atc]'),mainBtn=sec.querySelector('.ir-product__form [data-add]');
    if(sticky&&mainBtn&&hasIO){
      new IntersectionObserver(function(es){ var e=es[0]; sticky.classList.toggle('is-visible', !e.isIntersecting&&e.boundingClientRect.top<0); }).observe(mainBtn);
    }
  });
})();